import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IAuthModalState {
  isOpen: boolean;
  step: number;
  isRequired: boolean;
  continue: boolean;
  ticketId?: number | null;
  redirectUrl?: string | null;
  isAuthenticated: { status: boolean; loading?: boolean };
  data: {
    phone: string;
    code: string;
    age: number;
    role: string | null;
    region: number | null;
    subjectIds: number[];
    first_name: string;
    last_name: string;
    birthday: string;
    gender: string;
  };
  plan?: number | null;
}

export const initialState: IAuthModalState = {
  isOpen: false,
  step: 1,
  isRequired: false,
  continue: false,
  ticketId: null,
  redirectUrl: null,
  isAuthenticated: { status: false, loading: false },
  data: {
    phone: '',
    code: '',
    age: 20,
    role: null,
    region: null,
    subjectIds: [],
    first_name: '',
    last_name: '',
    birthday: '',
    gender: ''
  },
  plan: null
};

const authModalSlice = createSlice({
  name: 'auth-modal',
  initialState,
  reducers: {
    openAuthModal: state => {
      state.isOpen = true;
    },
    closeAuthModal: state => {
      state.isOpen = false;
    },
    nextStep: state => {
      state.step += 1;
    },
    prevStep: state => {
      if (state.step > 1) {
        state.step -= 1;
      }
    },
    setStep: (state, action: PayloadAction<number>) => {
      state.step = action.payload;
    },
    setRequiredModal: state => {
      state.isRequired = true;
    },
    setContinue: state => {
      state.continue = true;
    },
    setPhone: (state, action: PayloadAction<string>) => {
      state.data.phone = action.payload;
    },
    setRole: (state, action: PayloadAction<string | null>) => {
      state.data.role = action.payload;
    },
    setAge: (state, action: PayloadAction<number>) => {
      state.data.age = action.payload;
    },
    setRegion: (state, action: PayloadAction<number | null>) => {
      state.data.region = action.payload;
    },
    setSubject: (state, action: PayloadAction<number[]>) => {
      state.data.subjectIds = action.payload;
    },
    setTicket: (state, action: PayloadAction<number | undefined>) => {
      state.ticketId = action.payload;
    },
    resetTicketId: state => {
      state.ticketId = null;
    },
    resetRedirectUrl: state => {
      state.redirectUrl = null;
    },
    setRedirectUrl: (state, action: PayloadAction<string | undefined>) => {
      state.redirectUrl = action.payload;
    },
    setAuthenticated: (state, action: PayloadAction<{ status: boolean; loading?: boolean }>) => {
      state.isAuthenticated = action.payload;
    },
    setPlan: (state, action: PayloadAction<number | undefined>) => {
      state.plan = action.payload;
    }
  }
});

export const {
  openAuthModal,
  closeAuthModal,
  nextStep,
  prevStep,
  setStep,
  setRequiredModal,
  setContinue,
  setPhone,
  setRole,
  setAge,
  setRegion,
  setSubject,
  setTicket,
  resetTicketId,
  resetRedirectUrl,
  setRedirectUrl,
  setAuthenticated,
  setPlan
} = authModalSlice.actions;
export const authModalReducer = authModalSlice.reducer;
